import { useCallback, useEffect, useState } from 'react';
import { useFormState } from 'react-final-form';
import { useLazyQuery } from '@apollo/client';
import { FORM_VALUES } from '../utils/helpers/constants';
import { getLandmarksQuery } from '../api/queries';
import { InitCoordinatesType } from '../components/ItemCreationForm/AddNewItemForm/components/types';
import { LandmarksQuery } from '../graphql/graphql';

export const useLandmarks = (coordinates: InitCoordinatesType) => {
  const { values } = useFormState();
  const [locations, setLocations] = useState<LandmarksQuery['landmarks']>([]);

  const landmarksQueryVariables = {
    cityId: values[FORM_VALUES.cityId],
    latitude: coordinates?.lat,
    longitude: coordinates?.lng
  };

  const [getLandmarks] = useLazyQuery<LandmarksQuery>(getLandmarksQuery, {
    onCompleted: data => setLocations(data.landmarks),
    variables: landmarksQueryVariables
  });

  const handleLocationDelete = useCallback(
    id => {
      const updatedLocations =
        locations?.filter(location => location.id !== id) || [];
      setLocations(updatedLocations);
    },
    [locations]
  );

  useEffect(() => {
    getLandmarks({
      variables: {
        cityId: values[FORM_VALUES.cityId],
        latitude: coordinates?.lat,
        longitude: coordinates?.lng
      }
    });
  }, []);

  return {
    locations,
    getLandmarks,
    handleLocationDelete
  };
};
